import styled from 'styled-components';
import { H1, H2, H3, SectionParent } from '../../components/StyledComponents';

import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import virtual from '../../assets/v2/Pricing/virtual.svg';
import esper from '../../assets/v2/Pricing/esper-enhanced.svg';
import quality from '../../assets/v2/Pricing/quality.svg';
import custom from '../../assets/v2/Pricing/custom-android.svg';
import wifi from '../../assets/v2/Pricing/wifi.svg';
import help from '../../assets/v2/Pricing/help.svg';
import settings from '../../assets/v2/Pricing/settings.svg';
import quote from '../../assets/v2/Pricing/quote_purple.svg';
import quotewhite from '../../assets/v2/Pricing/quote_white.svg';
import demo from '../../assets/v2/Pricing/demo_purple.svg';
import { navigate } from '@reach/router';
import demowhite from '../../assets/v2/Pricing/demo_white.svg';
require('./pricing.scss');

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #ffffff;
  padding-top: 5rem !important;
  padding-bottom: 6rem !important;
  background-size: contain;
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    /* padding-bottom: 5rem !important; */
  }
  width: 100%;
  display: grid;
  justify-items: center;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  margin-top: 2rem;
  border-radius: 4px;
  width: 100%;
  margin-bottom: 1rem;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 768px) {
    /* grid-template-columns: repeat(2, 1fr); */
    padding: 2rem;
    width: 100%;
  }
  @media (max-width: 520px) {
    padding: 1rem;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 2.5rem;
    padding-right: 2rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 3;
  border-radius: 5px;
  @media (max-width: 1100px) {
    max-width: 100%;
    margin-bottom: 2rem;
    grid-column: span 2;
  }
`;

const BottomWrapper = styled.div`
  display: grid;
  grid-column: span 12;
  grid-template-columns: repeat(12, 1fr);
  width: 80%;
  justify-self: center;
  @media (max-width: 1024px) {
    grid-column: span 4;
    width: 100%;
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 520px) {
    grid-column: span 2;
    grid-template-columns: repeat(2, 1fr);
  }
`;
const GridItemBottom = styled.div`
  grid-column: span 4;
  justify-self: center;
  border-radius: 5px;
  max-width: 100%;
  margin-top: 2rem;
  @media (max-width: 1024px) {
    grid-column: span 2;
    margin-top: 0;
    justify-self: start !important;
    padding-left: 0 !important;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    justify-self: center !important;
    margin-bottom: 2rem;
  }
`;

const GridItemContent = styled(H3)`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left !important;
  color: #9095ab;
  @media (max-width: 520px) {
    margin-bottom: 0;
  }
`;
const InnerContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 768px) {
    justify-items: center;
  }
`;
const ImgWrapper = styled.div`
  display: grid;
  align-items: start;
  justify-content: end;
  padding-right: 1rem;
  grid-column: span 1;
  margin-bottom: 0.5rem;
  @media (max-width: 768px) {
    justify-items: center;
    margin-bottom: 0;
  }
`;
const TextWrapper = styled.div`
  display: grid;
  grid-column: span 2;
  @media (max-width: 768px) {
    margin-left: -1rem;
  }
  @media (max-width: 350px) {
    margin-left: 0;
  }
`;

const HeroTitle = styled.div`
  /* margin-left: 2.5rem; */
  padding-bottom: 1rem;
  color: #151828;
  text-align: center;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: bold;
  font-size: 21px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
`;

const HeroSubTitle = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #9095ab;
  padding-top: 1rem;
  padding-bottom: 2rem;
  width: 50%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const StyledImg = styled(LazyLoadImage)`
  height: 46px;
  @media (max-width: 768px) {
    height: 56px;
  }
`;
const TitlesContainer = styled.div`
  @media (max-width: 768px) {
    text-align: left;
    padding-left: 0rem;
  }
`;
const GridTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  min-height: 1em;
  font-weight: normal;
  margin-bottom: 0.5rem;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  @media (max-width: 520px) {
    min-height: 1.5rem;
    line-height: normal;
    margin-top: 0.5rem;
  }
`;

const BottomContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding-top: 4rem;
`;

const BottomBanner = styled.div`
  display: grid;
  border-radius: 8px;
  border: solid 1px #9095ab;
  background-color: #ffffff;
  grid-column: span 1;
  /* justify-self: end; */
  padding: 2rem;
  margin-left: 2rem;
  color: #735dbe;
  cursor: pointer;
  :hover {
    animation-name: example;
    animation-duration: 0.1s;
    box-shadow: 0 8px 18px 0 rgba(72, 82, 108, 0.19);
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    @keyframes example {
      /* 0% {
        background-color: #ffffff;
      } */
      100% {
        background-color: #735dbe;
      }
    }
  }
  @media (max-width: 520px) {
    grid-column: span 2;
    margin-left: 0;
    margin-bottom: 2rem;
  }
`;

const BottomBannerImage = styled.div`
  display: grid;
  justify-content: center;
  padding-bottom: 1rem;
`;

const BottomBannerText = styled.div`
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
`;
export default class PricingSectionTwo extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      hover1: false,
      hover2: false,
    };
  }
  mouseEnter = (index: number) => {
    if (index === 1) {
      this.setState({
        hover1: true,
      });
    } else {
      this.setState({
        hover2: true,
      });
    }
  };
  mouseExit = (index: number) => {
    if (index === 1) {
      this.setState({
        hover1: false,
      });
    } else {
      this.setState({
        hover2: false,
      });
    }
  };

  render() {
    return (
      <div>
        <SectionOne id="section-one-kiosk">
          <HeroTitle>
            {this.props?.messages?.PricingPagePremiumFeaturesTitle}
          </HeroTitle>
          <HeroSubTitle>
            {/* So, you have huge goals for Android mobility.{' '}
            <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
              Luckily,
            </span>{' '}
            you’re not alone. Esper’s services team can turn your roadmap into
            reality.
            <br />{' '} */}
            {this.props?.messages?.PricingPagePremiumFeaturesDesc1}
            {/* <span style={{ fontWeight: 'bold' }}>
              {' '}
              Esper’s Premium Features{' '}
            </span>
            are optional add-ons to our pricing tiers. Start a conversation to
            learn more. */}
            {this.props?.messages?.PricingPagePremiumFeaturesDesc2}
          </HeroSubTitle>
          <GridContainer>
            <GridItem>
              <InnerContainer>
                <ImgWrapper>
                  <StyledImg src={virtual} />
                </ImgWrapper>
                <TextWrapper>
                  <TitlesContainer>
                    <GridTitle>
                      {
                        this.props?.messages
                          ?.PricingPagePremiumFeaturesCloudHostingTitle
                      }{' '}
                    </GridTitle>
                  </TitlesContainer>
                  <GridItemContent>
                    {
                      this.props?.messages
                        ?.PricingPagePremiumFeaturesCloudHostingDesc
                    }
                  </GridItemContent>
                </TextWrapper>
              </InnerContainer>
            </GridItem>
            <GridItem>
              <InnerContainer>
                <ImgWrapper>
                  <StyledImg src={esper} />
                </ImgWrapper>
                <TextWrapper>
                  <TitlesContainer>
                    <GridTitle>
                      {
                        this.props?.messages
                          ?.PricingPagePremiumFeaturesEnhancedTitle
                      }
                    </GridTitle>
                  </TitlesContainer>
                  <GridItemContent>
                    {
                      this.props?.messages
                        ?.PricingPagePremiumFeaturesEnhancedDesc
                    }
                  </GridItemContent>
                </TextWrapper>
              </InnerContainer>
            </GridItem>
            <GridItem>
              <InnerContainer>
                <ImgWrapper>
                  <StyledImg src={quality} />
                </ImgWrapper>
                <TextWrapper>
                  <TitlesContainer>
                    <GridTitle>
                      {
                        this.props?.messages
                          ?.PricingPagePremiumFeaturesHardwareTitle
                      }
                    </GridTitle>
                  </TitlesContainer>
                  <GridItemContent>
                    {
                      this.props?.messages
                        ?.PricingPagePremiumFeaturesSupportDesc
                    }
                  </GridItemContent>
                </TextWrapper>
              </InnerContainer>
            </GridItem>
            <GridItem>
              <InnerContainer>
                <ImgWrapper>
                  <StyledImg src={custom} />
                </ImgWrapper>
                <TextWrapper>
                  <TitlesContainer>
                    <GridTitle>
                      {
                        this.props?.messages
                          ?.PricingPagePremiumFeaturesCustomAndroidTitle
                      }{' '}
                    </GridTitle>
                  </TitlesContainer>
                  <GridItemContent>
                    {
                      this.props?.messages
                        ?.PricingPagePremiumFeaturesCustomAndroidDesc
                    }
                  </GridItemContent>
                </TextWrapper>
              </InnerContainer>
            </GridItem>
            <BottomWrapper>
              <GridItemBottom>
                <InnerContainer>
                  <ImgWrapper>
                    <StyledImg src={wifi} />
                  </ImgWrapper>
                  <TextWrapper>
                    <TitlesContainer>
                      <GridTitle>
                        {
                          this.props?.messages
                            ?.PricingPagePremiumFeaturesAndroidOTATitle
                        }
                      </GridTitle>
                    </TitlesContainer>
                    <GridItemContent>
                      {
                        this.props?.messages
                          ?.PricingPagePremiumFeaturesAndroidOTADesc
                      }
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>
              <GridItemBottom>
                <InnerContainer>
                  <ImgWrapper>
                    <StyledImg src={help} />
                  </ImgWrapper>
                  <TextWrapper>
                    <TitlesContainer>
                      <GridTitle>
                        {
                          this.props?.messages
                            ?.PricingPagePremiumFeaturesOnsiteOnboardingTitle
                        }
                      </GridTitle>
                    </TitlesContainer>
                    <GridItemContent>
                      {
                        this.props?.messages
                          ?.PricingPagePremiumFeaturesOnsiteOnboardingDesc
                      }
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>
              <GridItemBottom>
                <InnerContainer>
                  <ImgWrapper>
                    <StyledImg src={settings} />
                  </ImgWrapper>
                  <TextWrapper>
                    <TitlesContainer>
                      <GridTitle>
                        {
                          this.props?.messages
                            ?.PricingPagePremiumFeaturesCloudPlatformTitle
                        }
                      </GridTitle>
                    </TitlesContainer>
                    <GridItemContent>
                      {
                        this.props?.messages
                          ?.PricingPagePremiumFeaturesCloudPlatformDesc
                      }
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>
            </BottomWrapper>
          </GridContainer>
          <BottomContainer>
            <BottomBanner
              className="parent"
              onMouseEnter={() => this.mouseEnter(1)}
              onMouseLeave={() => this.mouseExit(1)}
              onClick={() =>
                navigate(
                  this.props.messages?.locale !== 'en'
                    ? `/${this.props.messages?.locale}/contact-us`
                    : '/contact-us'
                )
              }
              id="pricing-get-a-quote"
            >
              <BottomBannerImage>
                <img src={this.state.hover1 === false ? quote : quotewhite} />
              </BottomBannerImage>
              <BottomBannerText className="child">
                {this.props?.messages?.PricingPageGetQuote}
              </BottomBannerText>
              <BottomBannerText className="child" style={{ color: '#9095ab' }}>
                {this.props?.messages?.PricingPageCustomPricing}
              </BottomBannerText>
            </BottomBanner>
            <BottomBanner
              className="parent"
              onMouseEnter={() => this.mouseEnter(2)}
              onMouseLeave={() => this.mouseExit(2)}
              id="pricing-schedule-demo"
              onClick={() =>
                navigate(
                  this.props.messages?.locale !== 'en'
                    ? `/${this.props.messages?.locale}/book-demo`
                    : '/book-demo'
                )
              }
            >
              <BottomBannerImage>
                <img src={this.state.hover2 === false ? demo : demowhite} />
              </BottomBannerImage>
              <BottomBannerText className="child">
                {this.props?.messages?.PricingPageDemo}
              </BottomBannerText>
              <BottomBannerText className="child" style={{ color: '#9095ab' }}>
                {this.props?.messages?.PricingPageTalkToRep}
              </BottomBannerText>
            </BottomBanner>
          </BottomContainer>
        </SectionOne>
      </div>
    );
  }
}
